import { Controller } from '@hotwired/stimulus'

import { hideOsSpecificElements } from '../utilities'

// Shows OS-specific PWA installation instructions.
export default class extends Controller {
  // Lifecycle

  connect () {
    hideOsSpecificElements()
  }

  // Properties

  get instructions () {
    return this.element.querySelector('#pwa-install-button-instructions')
  }
}
